import { cn } from "helper/Utils";
import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";

const Modal = ({
  onClose,
  isOpen,
  closeBtn = true,
  backdrop = true,
  modalClassName,
  className,
  closeBtnClassName,
  children,
  title,
}) => {
  useEffect(() => {
    const body = document.querySelector("body");
    if (isOpen) {
      body.classList.add("lock-scroll");
    } else {
      body.classList.remove("lock-scroll");
    }
    return () => {
      body.classList.remove("lock-scroll");
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={cn(
        // add blur + dark tint background here 👇
        "fixed inset-0 z-[1001] flex items-center justify-center p-4 overscroll-contain",
        backdrop
          ? "bg-black/60 backdrop-blur-md backdrop-saturate-150 transition-all duration-300"
          : "",
        modalClassName
      )}
      onClick={backdrop ? onClose : undefined}
    >
      {/* Modal Container */}
      <div
        className={cn(
          "bg-body text-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col min-h-0 mx-auto",
          className
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        {(title || closeBtn) && (
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700 flex-shrink-0">
            {title && <h2 className="text-xl font-semibold m-0">{title}</h2>}
            {closeBtn && (
              <button
                onClick={onClose}
                className={cn(
                  "text-gray-400 hover:text-white transition-colors p-2 rounded-lg hover:bg-gray-700 flex-shrink-0",
                  closeBtnClassName
                )}
              >
                <MdClose size={24} />
              </button>
            )}
          </div>
        )}

        {/* Single scroll area */}
        <div className="flex-1 overflow-auto min-h-0">
          <div className="p-6">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
